export default "__VITE_ASSET__M9_ezgwb__"